import { z } from 'zod'

export const ApiLoginResponseSchema = z.object({
  store_name: z.string(),
  store_address: z.string().optional(),
  store_avatar: z.string(),
  store_id: z.string(),
  owner_name: z.string(),
  email: z.string().email(),
  rest_status: z.number(),
  availability: z.number(),
  message: z.string(),
  currency_code: z.string(),
  currency_symbol: z.string(),
  country_code: z.string(),
  phone_number: z.string(),
  isMainRest: z.boolean(),
  store_type: z.union([
    z.literal('dark_store'),
    z.literal('restaurant'),
    z.literal('store')
  ]),
  usingCashCo: z.boolean(),
  /** Mongo ledger enroll; defaults to false when omitted by older backends. */
  store_ledger_wallet_enabled: z.boolean().default(false),
  token: z.string(),
  rbac: z
    .object({
      role_ids: z.array(z.string())
    })
    .optional(),
  authSource: z.string().optional(),
  login_as: z.enum(['owner', 'store_user']).optional(),
  lmd_core_tokens: z
    .object({
      access_token: z.string(),
      refresh_token: z.string()
    })
    .optional()
})

export const RoleSchema = z.object({
  id: z.string(),
  name: z.string()
})

export const PermissionSchema = z.object({
  resource: z.string(),
  operation: z.string()
})

export const ApiMeRolesResponseSchema = z.object({
  roles: z.array(RoleSchema),
  permissions: z.array(PermissionSchema),
  partial: z.boolean(),
  failed_role_ids: z.array(z.string()),
  login_as: z.enum(['owner', 'store_user']).optional()
})

export type ApiLoginResponse = z.infer<typeof ApiLoginResponseSchema>
export type StoreLoginAs = NonNullable<ApiLoginResponse['login_as']>
export type Permission = z.infer<typeof PermissionSchema>
export type ApiMeRolesResponse = z.infer<typeof ApiMeRolesResponseSchema>
export interface PermissionRequirement {
  resource: string
  operation: string
}
